import type { PayloadAction } from '@reduxjs/toolkit';
import { createSelector, createSlice } from '@reduxjs/toolkit';

import { DashboardColumns } from '@/interfaces/DashboardInterface/DashboardInterface';

interface DashboardState {
  columns: DashboardColumns[];
  colWidths: number[];
}

const initialState: DashboardState = {
  columns: [
    DashboardColumns.STATUS,
    DashboardColumns.DNI_CIF,
    DashboardColumns.CUSTOMER,
    DashboardColumns.DATE,
    DashboardColumns.AMOUNT,
  ],
  colWidths: [],
};

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setDashboardColumns: (state, action: PayloadAction<DashboardColumns[]>) => {
      state.columns = action.payload;
    },
    setColWidths: (state, action: PayloadAction<number[]>) => {
      state.colWidths = action.payload;
    },
  },
});

export const { setDashboardColumns, setColWidths } = dashboardSlice.actions;

export const selectColumnExists = createSelector(
  [(state: { dashboard: DashboardState }) => state.dashboard.columns,
    (_: any, columnToFind: DashboardColumns) => columnToFind],
  (columns, columnToFind) => columns.some((column) => column === columnToFind),
);

export const getSelectedColumns = createSelector(
  [(state: { dashboard: DashboardState }) => state.dashboard.columns],
  (columns) => columns.filter((column) => column !== DashboardColumns.STATUS),
);

export const getColWidths = createSelector(
  [(state: { dashboard: DashboardState }) => state.dashboard.colWidths],
  (colWidths) => colWidths,
);

export default dashboardSlice.reducer;
